<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="part">
<header><h1 class="parttitle" epub:type="title"><span epub:type="pagebreak" id="page_1" title="1">GATEWAY TO THE WEST</span></h1></header>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Part01.vue?6acbf9c7